import styled from '@emotion/styled';

import { Card as _Card } from '@hrworks/sui-core/Card';
import { Image as _Image } from '@hrworks/sui-core/Image';

const Card = styled(_Card)(({ theme }) => ({
  marginBottom: theme.eclipseTier1.spacing['12px'],
}));

const Container = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'start',
  justifyContent: 'space-between',
  gap: theme.eclipseTier1.spacing['12px'],
  padding: theme.eclipseTier1.spacing['16px'],
}));

const PersonInfo = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.eclipseTier1.spacing['12px'],
}));

const Image = styled(_Image)(({ theme }) => ({
  height: theme.eclipseTier1.sizing['40px'],
  width: theme.eclipseTier1.sizing['40px'],
}));

export const S = {
  Card,
  Container,
  PersonInfo,
  Image,
} as const;
